import { PositionSetRepository } from '@view-model/models/common/PositionSet/infrastructure/PositionSetRepository';
import { DescriptionPanel } from './DescriptionPanel';
import { DescriptionPanelCollection } from './DescriptionPanelCollection';
import { DescriptionPanelCollectionContents } from './DescriptionPanelCollectionContents';
import type { DescriptionPanelJSON, ModelId, ViewModelId } from 'balus-common';
import { RecordRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';

export class DescriptionPanelCascadeRepository {
  private readonly panelsRepository: RecordRepository<DescriptionPanelJSON, DescriptionPanel>;
  private readonly positionsRepository: PositionSetRepository;

  constructor(viewModelId: ViewModelId, modelId: ModelId) {
    this.panelsRepository = new RecordRepository(
      DescriptionPanel,
      RTDBPath.DescriptionPanel.panelsPath(viewModelId, modelId)
    );

    this.positionsRepository = new PositionSetRepository(RTDBPath.DescriptionPanel.positionsPath(viewModelId, modelId));
  }

  async saveContents(contents: DescriptionPanelCollectionContents): Promise<void> {
    const { panels, positions } = contents;
    await Promise.all([this.panelsRepository.save(panels.toRecord()), this.positionsRepository.saveAll(positions)]);
  }

  async loadContents(): Promise<DescriptionPanelCollectionContents> {
    const panels = await this.panelsRepository.get();
    const positions = await this.positionsRepository.loadAll();

    if (panels && positions) {
      return new DescriptionPanelCollectionContents(new DescriptionPanelCollection(Object.values(panels)), positions);
    } else {
      return DescriptionPanelCollectionContents.buildEmpty();
    }
  }
}
